"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.VIDEO = exports.PHONE = exports.IN_PERSON = void 0;
const PHONE = exports.PHONE = 'phone';
const VIDEO = exports.VIDEO = 'video';
const IN_PERSON = exports.IN_PERSON = 'in_person';